import React, { useEffect, useReducer, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import TextInput from '../../components/Common/TextInput';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import { useConfig } from '../../DataStore/ConfigContext';
import ajaxStudent from '../../util/remote/ajaxStudent';

const initialState = {
    fname: '',
    lname: '',
    reg_no: '',
    dob: '',
    sex: '',
    class: null,
    stream: null,
    admission_date: '',
    reporting_date: '',
    status: { value: 1, label: 'Active' },
    house: '',
    religion: '',
    nationality: '',
    residence: '',
    departure_date: '',
    other_reg: '',
    contact: '',
    guardian: '',
    photo: null,
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return { ...state, [action.field]: action.value };
        case 'reset':
            return initialState;
        default:
            return state;
    }
};

const NewStudentPage = () => {
    const { getClasses, classes, getReligions, getCountries, religions, countries, getResidences, residences, houses, getHouses } = useConfig();
    const [notify, setNotify] = useState(null);
    const [loading, setLoading] = useState(false);
    const [formData, dispatchForm] = useReducer(reducer, initialState);

    useEffect(() => {
        getClasses();
        getReligions();
        getCountries();
        getResidences();
        getHouses();
    }, []);

    const handleInputChange = (field, value) => {
        dispatchForm({ type: 'update', field, value });
        if (field === 'class') dispatchForm({ type: 'update', field: 'stream', value: null });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(formData.fname.length === 0 || formData.lname.length === 0) {
            setNotify(<Notification type="danger" message="Please fill in the first name and surname." />);
            return;
        }
        if(!formData.sex) {
             setNotify(<Notification type="danger" message="Please select the Gender" />);
            return;
        }

        if(!formData.class.value) {
            setNotify(<Notification type="danger" message="Please select a class." />);
            return;
        }

        if(!formData.residence) {
            setNotify(<Notification type="danger" message="Please select student residence." />);
            return;
        }

        const data = {
            first_name: formData.fname,
            last_name: formData.lname,
            sex: formData.sex,
            class_id: formData.class.value,
            stream_id: formData.stream?.value || null,
            admission_date: formData.admission_date,
            reporting_date: formData.reporting_date,
            birthday: formData.dob,
            house_id: formData.house,
            religion_id: formData.religion,
            residence_id: formData.residence,
            custom_id: formData.other_reg,
        }


        setLoading(true);
        const server_response = await ajaxStudent.registerStudent(data);
        setLoading(false);

        if (server_response.status === 'OK') {
            setNotify(<Notification type="success" message={server_response.message} />);
            dispatchForm({ type: 'reset' });
        } else {
            setNotify(<Notification type="danger" message={server_response.message} />);
        }
    };

    const religionOptions = religions?.map(r => ({ label: r.religion, value: r.religion_id })) || [];
    const countryOptions = countries?.map(c => ({ label: c.nationality, value: c.nation_id })) || [];
    const residenceOptions = residences?.map(r => ({ label: r.residence_name, value: r.id })) || [];
    const houseOptions = Array.isArray(houses) ? houses.map(h => ({ label: h.house, value: h.house_id })) : [];
    const classOptions = Array.isArray(classes)? classes.map(cls => ({ label: `${cls.class_name} (${cls.level?.level || ''})`, value: cls.class_id, streams: cls.streams || [] })) : [];
    const streamOptions = formData.class?.streams?.map(s => ({ label: s.stream_name, value: s.stream_id })) || [];
   
    return (
        <PageContainer>
            <MainContent>
                <PageTitle title="New Student" description="Enroll new student to the system." iconClass="fa fa-users" />

                <div className="card mb-3">
                    <div className="card-body">
                        {notify}
                        <form onSubmit={handleSubmit}>
                            <h5 className="mb-3">Basic Information</h5>
                            <div className="row">
                                <div className="col-md-4 mb-3"><TextInput label="Surname" placeholder="Surname" value={formData.lname} onChange={(e) => handleInputChange('lname', e.target.value)} required wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput label="First Name" placeholder="First Name" value={formData.fname} onChange={(e) => handleInputChange('fname', e.target.value)} required wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput type="select" label="Gender" options={[{ label: 'Male', value: 'Male' }, { label: 'Female', value: 'Female' }]} onChange={(item) => handleInputChange('sex', item.value)} required wrap /></div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-3"><TextInput type="date" label="Date of Birth" value={formData.dob} onChange={(e) => handleInputChange('dob', e.target.value)} wrap /></div>
                                {/* <div className="col-md-4 mb-3"><TextInput type="select" label="Status" options={statusOptions} onChange={(item) => handleInputChange('status', item.value)} required wrap /></div> */}
                            </div>

                            <h5 className="mb-3 mt-4">Admission Information</h5>
                            <div className="row">
                                <div className="col-md-4 mb-3"><TextInput type="select" label="Class" options={classOptions} onChange={(item) => handleInputChange('class', item)} required wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput type="select" label="Stream" options={streamOptions} onChange={(item) => handleInputChange('stream', item)} wrap /></div>

                                <div className="col-md-4 mb-3"><TextInput type="date" label="Admission Date" value={formData.admission_date} onChange={(e) => handleInputChange('admission_date', e.target.value)} wrap /></div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-3"><TextInput type="select" label="House" options={houseOptions} onChange={(item) => handleInputChange('house', item.value)} wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput type="select" label="Religion" options={religionOptions} onChange={(item) => handleInputChange('religion', item.value)} wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput label="Custom ID" value={formData.other_reg} onChange={(e) => handleInputChange('other_reg', e.target.value)} wrap /></div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-3"><TextInput type="select" label="Nationality" options={countryOptions} onChange={(item) => handleInputChange('nationality', item.value)} wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput type="select" required label="Student Residence" options={residenceOptions} onChange={(item) => handleInputChange('residence', item.value)} wrap /></div>
                                <div className="col-md-4 mb-3"><TextInput type="date" label="Reporting Date" value={formData.reporting_date} onChange={(e) => handleInputChange('reporting_date', e.target.value)} wrap /></div>
                            </div>
                            
                            {/* SUBMIT */}
                            <div className="row">
                                <div className="col-md-12 text-right mt-3">
                                {!loading ? (
                                    <button className="btn btn-primary btn-lg" type="submit">Register Student</button>
                                ) : (
                                    <ActivityLoader />
                                )}
                            </div>
                        </div>
                           
                        </form>
                    </div>
                </div>
            </MainContent>
        </PageContainer>
    );
};

export default NewStudentPage;
